import React, { ComponentType, useRef, useState } from 'react'
import { Text } from 'src/ui/basic/Text'
import { useContextFetch } from 'src/fetch/useContextFetch'
import { AxiosInstance } from 'axios'
import { useTran } from 'src/i18n/useTran'
import moment from 'moment'
import { msg } from 'src/i18n/texts/keys'
import { css } from 'src/ui/style/css'
import { getAppContext } from 'src/context/AppContext'
import {
    getCachedCoords,
    getGeolocation,
    supportsGeolocation,
    useGeolocationPermission
} from '../geo/locationService'
import { Coordinates } from '../api/defs/Coordinates.type'
import CustomModal from 'src/app/Modal'
import { View } from 'src/ui/basic/View'
import { useUser } from '../auth/user/useUser'
import { isMobileScreen } from '../ui/style/ScreenSize'
import debounce from 'lodash/debounce'

const getVersion = (http: AxiosInstance, path: string): Promise<string> => {
    return http.get(path).then(r => r.data.version)
}

export const Version: ComponentType = () => {
    const t = useTran()
    // const version =
    //     useContextFetch(ctx => getVersion(ctx.http, '/_info'), null) ||
    //     getAppContext()?.config?.appVerion
    const version = getAppContext()?.config?.appVerion
    const apiVersion = useContextFetch(
        ctx => getVersion(ctx.http, '/api/info'),
        null
    )
    const [loading, setLoading] = useState(false)
    const [tapCount, setTapCount] = useState(0)
    const [isOpen, setIsOpen] = useState(false)
    const [debugData, setDebugData] = useState<{
        date: string
        allowedGeolocation: boolean
        coords: Coordinates | null
        gpsCache: Coordinates | null
    }>()
    const user = useUser()
    const isMobile = isMobileScreen()
    const resetTimerRef = useRef<NodeJS.Timeout | null>(null)
    const permissionStatus = useGeolocationPermission()

    const doLocation = async () => {
        setLoading(true)
        if (supportsGeolocation()) {
            if (permissionStatus === 'denied') {
                setDebugData({
                    date: moment().format('DD.MM.YYYY HH:mm:ss'),
                    allowedGeolocation: false,
                    coords: null,
                    gpsCache: getCachedCoords()
                })
                setIsOpen(true)
                setLoading(false)
                return
            }
            const coords = await getGeolocation(false)
            setDebugData({
                date: moment().format('DD.MM.YYYY HH:mm:ss'),
                allowedGeolocation: permissionStatus === 'granted',
                coords: permissionStatus === 'granted' ? coords : null,
                gpsCache: getCachedCoords()
            })
            setIsOpen(true)
            setLoading(false)
        } else {
            setDebugData({
                date: moment().format('DD.MM.YYYY HH:mm:ss'),
                allowedGeolocation: false,
                coords: null,
                gpsCache: getCachedCoords()
            })
            setIsOpen(true)
            setLoading(false)
        }
    }

    const handleTripleTap = debounce(doLocation, 300)

    const handleTouchStart = () => {
        setTapCount(prev => {
            const newCount = prev + 1
            if (resetTimerRef.current) clearTimeout(resetTimerRef.current)
            if (newCount === 3) {
                handleTripleTap()
                return 0
            }
            resetTimerRef.current = setTimeout(() => setTapCount(0), 1000)
            return newCount
        })
    }

    return (
        <>
            <Text
                css={css`
                    font-size: 0.8em;
                `}
                onClick={e => e.detail === 3 && doLocation()}
                onTouchStart={isMobile ? handleTouchStart : undefined}
            >
                {loading
                    ? t(msg.myZone.myBoxes.locationAccessCheck.text) + '...'
                    : `${t(msg.ui.footer.version)}: ${version} ${
                          apiVersion ? ` (api: ${apiVersion})` : ''
                      }`}
            </Text>
            {isOpen && (
                <CustomModal open={isOpen} onClose={() => setIsOpen(false)}>
                    <View
                        horizontal={false}
                        css={th => css`
                            row-gap: ${th.spacing.md};
                            padding: ${th.spacing.md};
                        `}
                    >
                        <Text>{`Dátum a čas: ${debugData?.date}`}</Text>
                        <Text>{`Prihlásený používateľ: ${
                            user?.email || '-'
                        }`}</Text>
                        <Text>{`Poloha GPS povolená: ${
                            debugData?.allowedGeolocation ? 'Áno' : 'Nie'
                        }`}</Text>
                        <Text>{`Poloha GPS: ${
                            debugData?.coords
                                ? `${debugData?.coords?.lat}, ${debugData?.coords?.lng}`
                                : '-'
                        }`}</Text>
                        <Text>{`Poloha GPS cache: ${
                            debugData?.gpsCache
                                ? `${debugData?.coords?.lat}, ${debugData?.coords?.lng}`
                                : '-'
                        }`}</Text>
                    </View>
                </CustomModal>
            )}
        </>
    )
}
